module.exports = __webpack_public_path__ + "img/helin_mob.f969553.webp";